import React ,{useState,useEffect} from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {getProjectStatusList} from '../function-components/Redux/ProjectMasterSlice';
import {useDispatch, useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import './ProjectStatus.css';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
//const baseURL = "http://localhost:1101";
const TeamStatus = () => {
const dispatch = useDispatch();
const projectStatusList = useSelector((state) => state.projectMaster.projectStatusList);
const [filteredItem, setFilteredItem] = useState("");
const [filteredValues, setFilteredValues] = useState(projectStatusList);
const [page, setPage] = useState(1);
const PER_PAGE = 6;
const startIdx = (page - 1) * PER_PAGE;
const endIdx = startIdx + PER_PAGE;
const currentItems = filteredValues.slice(startIdx,  endIdx);
const count = Math.ceil(filteredValues.length / PER_PAGE);
const [snackbar, setSnackbar] = useState(null);
const handleCloseSnackbar = () => setSnackbar(null);

useEffect(() => {
  setFilteredValues(projectStatusList)
},[projectStatusList]);

useEffect(() => {
if(filteredItem == undefined || filteredItem == "") {
setFilteredValues(projectStatusList)}
},[filteredItem]);

const handleChange = (e, p) => {
    setPage(p);
  };
const theme = createTheme({
        typography: {
        fontFamily: "Graphik-Regular",
        },
        components: {
          MuiInput: {
            styleOverrides: {
              underline: {
                '&:hover:not(.Mui-disabled):before': {
                  borderBottom: 'none !important',
                },
                '&.Mui-focused:after': {
                  borderBottom: 'none !important',
                },
              },
            },
          },
        },
        });
        
const style = {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
         };


const useStyles = makeStyles({
          idCell: {
            color: '#7500C0', 
          },
          centeredCell: {
              display: 'flex !important',
              justifyContent: 'center !important',
              alignItems: 'center !important',
            },
        root: {
              '& .MuiDataGrid-cell': {
                border: 'none !important'
              },
              '& .MuiDataGrid-columnHeader': {
                borderBottom: 'none !important'
              }
            },
        });
        
const classes = useStyles();

const getStatusTextAndStyle = (status) => {
    switch (status) {
      case "1":
        return { text: 'Yet to Start', color: 'blue' };
      case "2":
        return { text: 'In Progress', color: '#FE7280' };
      case "3":
        return { text: 'Completed', color: '#02A873' };
      case "4":
        return { text: 'New', color: '#460073' };
      default:
        return { text: '', color: 'black' };
    }
  };

  const formatDate = (dateString) => {
    if (dateString === '0000-00-00') {
      return 'DD/MM/YYYY';
    }
    const date = new Date(dateString);
    const options = {day: '2-digit', month: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  };

   const columns = [
    { field: 'id', headerName: 'SL.#', width: 70, filterable: false },
    {
      field: 'username',
      headerName: 'Enterprise ID',
      width: 150,
      editable: false,
    },
    {
        field: 'requestType',
        headerName: 'Request Type',
        width: 120,
        editable: false,
    },
    {
      field: 'projectName',
      headerName: 'Project Name',
      width: 120,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value === '' ? 'NA' : params.value;
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >
            {cellValue}
          </div>
        );
      },
    },
    {
    field: 'team',
    headerName: 'Team',
    width: 110,
    editable: false,
    },
    {
    field: 'status',
    headerName: 'Status',
    width: 110,
    editable: false,
    renderCell: (params) => {
        const { text, color } = getStatusTextAndStyle(params.value);
        return <span style={{ color }}>{text}</span>;
      },
    },
    {
    field: 'taskType',
    headerName: 'Task Type',
     width: 140,
    editable: false,
    },
    {
    field: 'subTask',
    headerName: 'Sub Task',
    width: 120,
    editable: false,
    renderCell: (params) => {
      const cellValue = params.value || 'NA';
      return (
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={cellValue}
        >
          {cellValue}
        </div>
      );
    },
    },
    {
      field: 'otherTaskType',
      headerName: 'Other Task Type',
       width: 150,
      editable: false,
      renderCell: (params) => {
        const cellValue = params.value === 'select' ? 'NA' : params.value;
        return (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={cellValue}
          >
            {cellValue}
          </div>
        );
      },
    },
    {
    field: 'startDate',
    headerName: 'Start Date',
    width: 120,
    editable: false,
    renderCell: (params) => <span>{formatDate(params.value)}</span>
    },
    {
    field: 'endDate',
    headerName: 'End Date',
    width: 120,
    editable: false,
    renderCell: (params) => <span>{formatDate(params.value)}</span>
    },
    {
    field: 'effort',
    headerName: 'Efforts (in hrs)',
    width: 120,
    editable: false,
    cellClassName: classes.centeredCell, 
    // renderCell: (params) => {
    //     return `${params.value} Hours`;
    //   },
    },
    {
    field: 'description',
    headerName: 'Description',
    width: 120,
    editable: false,
    },
]
const rows = currentItems.map((data, i) => ({ ...data, id: startIdx + i + 1 }));

useEffect(() => {
    dispatch(getProjectStatusList());
  }, []);

  useEffect(() => {
    if (filteredItem === undefined || filteredItem === "") {
      setFilteredValues(projectStatusList);
    } else {
      const filteredData = projectStatusList?.filter(item => (
        (typeof item.username === 'string' && item.username.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.projectName === 'string' && item.projectName.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.requestType === 'string' && item.requestType.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.otherTaskType === 'string' && item.otherTaskType.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.team === 'string' && item.team.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.description === 'string' && item.description.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.taskType === 'string' && item.taskType.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.startDate === 'string' && item.startDate.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.endDate === 'string' && item.endDate.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.status === 'string' && item.status.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.subTask === 'string' && item.subTask.toLowerCase().includes(filteredItem.toLowerCase())) ||
        (typeof item.effort === 'string' && item.effort.toLowerCase().includes(filteredItem.toLowerCase()))
      ));
      setFilteredValues(filteredData);
    }
  }, [filteredItem, projectStatusList]);

  const handleFilterModelChange = (newValue) => {
    const newFilteredItem = newValue?.items?.length > 0 ? newValue.items[0].value : "";
    setFilteredItem(newFilteredItem);
  };

    return(
        <>
        <ThemeProvider theme={theme}>
        <Box sx={{width:"93.5%",margin:"auto",paddingTop:"30px", paddingBottom:"10px"}}>
        <Typography sx={{fontWeight: "bold", fontSize: "24px"}}>Team Status</Typography>
        </Box>
      <Box sx={{ height: 380, width: '93.5%', margin:'auto' }}>
        <DataGrid className='projectControlTable'
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 6,
              },
            },
          }}
          pageSizeOptions={[6]}
          checkboxSelection={false}
          disableRowSelectionOnClick
          disableColumnSelector={true}
          hideFooterPagination   
          onFilterModelChange={handleFilterModelChange}                        
        />
        {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
        )}
        <Stack className="pagination_stack_projectstatus">
          <Pagination count={count} page={page} onChange={handleChange} color="secondary" />
        </Stack>
      </Box>
    </ThemeProvider>
        
        </>
    )
}

export default TeamStatus;

